import {
    LOGIN, LOGOUT, REGISTER, RELOGIN
} from '../index.types';

export function register(data) {
    return {
        type: REGISTER,
        data
    }
}
export function login(data) {
    return {
        type: LOGIN,
        data,
    };
}

export function logOut(data) {
    return {
        type: LOGOUT,
        data,
    };
}

export function relogin(data = {}) {
    return {
        type: RELOGIN,
        data,
    };
}

